<template>
  <div class="page page-category">
    <div class="category-block"
         v-for="(block, blockIndex) in category"
         :key="blockIndex"
    >
      <span class="title">{{ block.name.text }}</span>
      <div class="category-list">
        <ym-button class="category-item"
                   v-for="(item, index) in block.list"
                   :key="index"
                   size="medium"
                   @click="handleClick(item)"
        >
          {{ item.name }}
        </ym-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import { getCategoryInfo } from '@/services/category';

  export default {
    name: 'PageCategory',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      'ym-button': Button,
    },
    data() {
      return {
        category: [],
        render: {
          pageTitle: '分类',
        },
      };
    },
    methods: {
      async fetchData(type) {
        const data = await getCategoryInfo(type);
        this.category = data.category;
        this.render = data.render;
      },
      handleClick(item) {
        const { value: category } = item;
        const route = {
          name: 'AudioList',
          query: { category },
        };
        this.$router.push(route);
      },
    },
    created() {
      const { $route } = this;
      const { params } = $route;
      const { type } = params;
      this.fetchData(type);
    },
    beforeRouteUpdate(to, from, next) {
      const { params } = to;
      const { type } = params;
      this.fetchData(type);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-category {
    overflow-x: hidden;
    min-height: 100%;
    box-sizing: border-box;
    padding-top: @size-base;
    background: @color-white;
  }

  .category-block {
    margin-bottom: @size-large;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .title {
    margin-bottom: @size-base;
    position: relative;
    font-weight: @font-weight-bold;
    font-size: @font-size-medium;
    color: @color-text-base;
    text-align: center;
    line-height: 1;
    &:after {
      content: '';
      position: absolute;
      width: @size-medium;
      height: 2px;
      background: @color-text-light;
      right: -@size-large;
      top: 50%;
    }
    &:before {
      content: '';
      position: absolute;
      width: @size-medium;
      height: 2px;
      background: @color-text-light;
      left: -@size-large;
      top: 50%;
    }
  }
  .category-list {
    padding: 0 @size-base;
    margin: -(@size-base / 4);
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
  }

  .category-item {
    flex-shrink: 0;
    width: 220px;
    font-size: @font-size-base;
    margin: (@size-base / 4);
  }
</style>
